(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdsffsd"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.plant-catalog').forEach(function (root) {

      // Filtros decorativos: solo alternan el estado visual "activo"
      root.querySelectorAll('[data-filter-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          root.querySelectorAll('[data-filter-pill]').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
        });
      });

      // Animación de aparición al hacer scroll (fade + slide), nativa, sin librerías
      if (root.dataset.animate === 'true' && 'IntersectionObserver' in window) {
        var cards = root.querySelectorAll('.plant-catalog__card--animate');
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
        cards.forEach(function (card) { observer.observe(card); });
      } else {
        root.querySelectorAll('.plant-catalog__card--animate').forEach(function (card) {
          card.classList.add('is-visible');
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
